const ShopActionTypes = {
  FETCH_COLLECTIONS_START: 'FETCH_COLLECTIONS_START',
  FETCH_COLLECTIONS_SUCCESS: 'FETCH_COLLECTIONS_SUCCESS',
  FETCH_COLLECTIONS_FAILURE: 'FETCH_COLLECTIONS_FAILURE',
  SET_COLOR_FILTER: 'SET_COLOR_FILTER',
  SET_PRICE_FILTER: 'SET_PRICE_FILTER',
  SET_SIZE_FILTER: 'SET_SIZE_FILTER',
  CLEAR_ALL_FILTERS: 'CLEAR_ALL_FILTERS',
  TOGGLE_FILTER_MENU: 'TOGGLE_FILTER_MENU',
  SET_GENDER: 'SET_GENDER',
  SET_CATEGORY: 'SET_CATEGORY',
  REFRESH_COLLECTIONS: 'REFRESH_COLLECTIONS',
  REFRESH_FILTERS: 'REFRESH_FILTERS',
};

export default ShopActionTypes;
